function normalizeNameCandidate(value) {
  const normalized = String(value || "")
    .replace(/\s+/g, " ")
    .trim();

  if (!normalized) {
    return "";
  }

  return /[\p{L}\p{N}]/u.test(normalized) ? normalized : "";
}

function normalizeOrigin(origin = "") {
  const normalized = String(origin || "").trim();
  return normalized ? normalized.replace(/\/+$/, "") : "https://min.cool";
}

function normalizeAccountId(value = "") {
  return String(value || "").trim();
}

export function buildProfileDisplayName(profile = {}) {
  const firstName = normalizeNameCandidate(profile?.firstName);
  const lastName = normalizeNameCandidate(profile?.lastName);
  const fullName = [firstName, lastName].filter(Boolean).join(" ");

  if (fullName) {
    return fullName;
  }

  return normalizeNameCandidate(profile?.nickname) || firstName || lastName || "";
}

export function resolveSelfChatName(payload) {
  return (
    normalizeNameCandidate(payload?.account?.displayName)
    || buildProfileDisplayName(payload?.profile)
    || "Your WhatsApp chat"
  );
}

export function buildSelfChatRelinkUrl({ origin = "", accountId = "" } = {}) {
  const url = new URL("/relink", `${normalizeOrigin(origin)}/`);
  const normalizedAccountId = normalizeAccountId(accountId);
  if (normalizedAccountId) {
    url.searchParams.set("accountId", normalizedAccountId);
  }
  return url.toString();
}

export function buildSelfChatWelcomeMessage({ relinkUrl = "" } = {}) {
  const resolvedRelinkUrl = String(relinkUrl || "").trim() || buildSelfChatRelinkUrl();
  return [
    "Welcome to Min.",
    "",
    "When you send a voice note, Min can send a short follow-up in that chat.",
    "When you receive a voice note, Min can send you the summary here.",
    "",
    `Manage settings or relink WhatsApp anytime: ${resolvedRelinkUrl}`,
    "",
    "If WhatsApp Web disconnects, come back to this link and relink.",
    "Next: send yourself a voice note here to test it.",
  ].join("\n");
}

export function buildSelfChatPreviewMessages({ relinkUrl = "" } = {}) {
  return [
    {
      from: "Min",
      text: buildSelfChatWelcomeMessage({ relinkUrl }),
    },
  ];
}
